<template>
	<managing-section class="product-list-filter" :columnCount="2">
		<managing-box title="검색구분">
			<RadioList
				:value="searchType"
				:radio-list="searchTypeList"
				class="product-list-filter__search-type"
				@input="onValueChange([{ key: 'searchType', value: $event }])"
			/>
		</managing-box>
		<managing-box v-if="searchType === 0" title="제품명">
			<input
				type="text"
				placeholder="제품명을 입력하세요"
				@input="
					onValueChange([
						{ key: 'productTitle', value: $event.target.value },
					])
				"
				:value="productTitle"
			/>
		</managing-box>
		<managing-box v-if="searchType === 1" title="제품번호">
			<InputText
				class="product-list-filter__id-product"
				mode="number"
				:inputWidth="100"
				inputWidthUnit="%"
				@input="onValueChange([{ key: 'idProduct', value: $event }])"
				:propValue="idProduct"
				placeholder="제품 번호 입력"
			/>
		</managing-box>
		<managing-box v-if="searchType === 2" title="스토어">
			<select v-model="idBrandTypeModel">
				<option
					v-for="storeItem in storeList"
					:key="storeItem.id"
					:value="storeItem.id"
				>
					{{ storeItem.name }}
				</option>
				<option>스토어 선택(필수)</option>
			</select>
		</managing-box>
		<managing-box title="카테고리">
			<CategorySelector
				class="product-list-filter__category-selector"
				:disabled="searchType === 1"
				v-if="categorySelector"
				@change="categoryChange"
				ref="categorySelector"
			/>
		</managing-box>
		<managing-box title="가격">
			<period-box
				mode="number"
				:comma="true"
				:disabled="searchType === 1"
				@change="
					onValueChange([
						{ key: 'minPrice', value: $event.from },
						{ key: 'maxPrice', value: $event.to },
					])
				"
				fromPlaceholder="최소가"
				toPlaceholder="최대가"
				:inputWidth="100"
				:fromValue="minPrice"
				:toValue="maxPrice"
			/>
		</managing-box>
		<managing-box title="제품 설명">
			<input
				type="text"
				@input="
					onValueChange([
						{ key: 'productText', value: $event.target.value },
					])
				"
				:value="productText"
				:disabled="searchType === 1"
			/>
		</managing-box>
		<managing-box title="성분 등록일">
			<DateRange
				:value="{
					from: startFactorsInsertDate,
					to: endFactorsInsertDate,
				}"
				type="date"
				:disabled="searchType === 1"
				@input="
					onValueChange([
						{ key: 'startFactorsInsertDate', value: $event.from },
						{ key: 'endFactorsInsertDate', value: $event.to },
					])
				"
			/>
		</managing-box>
		<managing-box title="성분 수정일">
			<DateRange
				:value="{
					from: startModifiedFactorsDate,
					to: endModifiedFactorsDate,
				}"
				type="date"
				:disabled="searchType === 1"
				@input="
					onValueChange([
						{ key: 'startModifiedFactorsDate', value: $event.from },
						{ key: 'endModifiedFactorsDate', value: $event.to },
					])
				"
			/>
		</managing-box>
		<managing-box title="펑점">
			<div class="product-list-filter__rating rating range">
				<input
					type="text"
					ref="minRatingAvg"
					aria-label="최소 평점"
					placeholder="최소 평점"
					:value="minRatingAvg"
					class="rating__min range__item"
					@input="onRatingInput($event, 'minRatingAvg')"
				/>
				<span>~</span>
				<input
					type="text"
					ref="maxRatingAvg"
					aria-label="최대 평점"
					placeholder="최대 평점"
					:value="maxRatingAvg"
					class="rating__max range__item"
					@input="onRatingInput($event, 'maxRatingAvg')"
				/>
			</div>
		</managing-box>
		<managing-box title="단종 여부">
			<RadioList
				:value="isDiscontinue"
				:radio-list="isDiscontinueList"
				:disabled="searchType === 1 ? 'all' : false"
				@input="
					onValueChange([{ key: 'isDiscontinue', value: $event }])
				"
			/>
		</managing-box>
		<managing-box title="전시 여부">
			<RadioList
				:value="isDisplay"
				:radio-list="isDisplayList"
				@input="onValueChange([{ key: 'isDisplay', value: $event }])"
			/>
		</managing-box>
		<managing-box title="브랜드">
			<search-brand
				:disabled="searchType === 1"
				@change="
					onValueChange([{ key: 'idBrand', value: $event.idBrand }])
				"
				ref="idBrand"
				searcherPlaceholder="브랜드 찾기"
				selectedPlaceholder="브랜드를 선택해 주세요"
				:show-if-is-display="true"
				:useLastBrand="true"
			/>
		</managing-box>
		<managing-box title="키워드">
			<input
				type="text"
				@input="
					onValueChange([
						{ key: 'keyword', value: $event.target.value },
					])
				"
				:value="keyword"
				:disabled="searchType === 1"
			/>
		</managing-box>
		<managing-box title="등록일">
			<DateRange
				:value="{ from: startDate, to: endDate }"
				type="date"
				:disabled="searchType === 1"
				@input="
					onValueChange([
						{ key: 'startDate', value: $event.from },
						{ key: 'endDate', value: $event.to },
					])
				"
			/>
		</managing-box>
		<managing-box title="수정일">
			<DateRange
				:value="{ from: startModifiedDate, to: endModifiedDate }"
				type="date"
				:disabled="searchType === 1"
				@input="
					onValueChange([
						{ key: 'startModifiedDate', value: $event.from },
						{ key: 'endModifiedDate', value: $event.to },
					])
				"
			/>
		</managing-box>
		<managing-box title="출시월">
			<DateRange
				:value="{ from: startReleaseDate, to: endReleaseDate }"
				type="month"
				:disabled="searchType === 1"
				@input="
					onValueChange([
						{ key: 'startReleaseDate', value: $event.from },
						{ key: 'endReleaseDate', value: $event.to },
					])
				"
			/>
		</managing-box>
		<managing-box title="리뷰수">
			<div class="product-list-filter__rating rating range">
				<input
					type="text"
					ref="minReviewCount"
					aria-label="최소 리뷰수"
					placeholder="최소 리뷰수"
					:value="minReviewCount"
					class="rating__min range__item"
					@input="onReviewCountInput($event, 'minReviewCount')"
				/>
				<span>~</span>
				<input
					type="text"
					ref="maxReviewCount"
					aria-label="최대 리뷰수"
					placeholder="최대 리뷰수"
					:value="maxReviewCount"
					class="rating__max range__item"
					@input="onReviewCountInput($event, 'maxReviewCount')"
				/>
			</div>
		</managing-box>
		<ManagingBox title="컬러/타입">
			<input
				type="text"
				@input="
					onValueChange([
						{ key: 'colorType', value: $event.target.value },
					])
				"
				:value="colorType"
				:disabled="searchType === 1"
			/>
		</ManagingBox>
	</managing-section>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import RadioList from '@/components/RadioList';
	import PeriodBox from '@/components/PeriodBox.vue';
	import DateRange from '@/components/DateRange';
	import CategorySelector from '@/components/product/CategorySelector.vue';
	import InputText from '@/components/InputText.vue';
	import util from '@/util';
	import match from 'pyonkoro.match';

	export default {
		name: 'ProductListFilter',
		components: {
			ManagingSection,
			ManagingBox,
			SearchBrand,
			RadioList,
			PeriodBox,
			DateRange,
			CategorySelector,
			InputText,
		},
		props: [
			'idProduct',
			'searchType',
			'productTitle',
			'minPrice',
			'maxPrice',
			'productText',
			'startFactorsInsertDate',
			'endFactorsInsertDate',
			'startModifiedFactorsDate',
			'endModifiedFactorsDate',
			'startDate',
			'endDate',
			'isDiscontinue',
			'keyword',
			'idBrandType',
			'storeList',
			'startReleaseDate',
			'endReleaseDate',
			'isDisplay',
			'startModifiedDate',
			'endModifiedDate',
			'minRatingAvg',
			'maxRatingAvg',
			'minReviewCount',
			'maxReviewCount',
			'colorType',
		],
		data() {
			return {
				categorySelector: true,
				searchTypeList: [
					{ id: 0, value: '제품명/조건 검색' },
					{ id: 1, value: '제품 번호로 검색' },
					{ id: 2, value: '스토어별로 검색' },
				],
				isDiscontinueList: [
					{ id: null, value: '전체' },
					{ id: true, value: '단종' },
					{ id: false, value: '미단종' },
				],
				isDisplayList: [
					{ id: null, value: '전체' },
					{ id: true, value: '전시중' },
					{ id: false, value: '전시안함' },
				],
			};
		},
		computed: {
			idBrandTypeModel: {
				get() {
					return this.idBrandType;
				},
				set(nv) {
					this.emitsChange([{ key: 'idBrandType', value: nv }]);
				},
			},
		},
		mounted() {
			if (this.searchType !== 1) {
				this.setCategory(this.$route.query);
			}
		},
		methods: {
			emitsChange(params) {
				this.$emit('change', params);
			},
			onValueChange(params) {
				this.emitsChange(params);
			},
			onRatingInput(e, target) {
				const value = e.target.value;
				const emit = value =>
					this.emitsChange([
						{
							value,
							key: target,
						},
					]);
				const inputValue = match(
					[
						[v => v.toString().length === 0, () => ''],
						[v => Number(v) > 5, () => 5],
						[v => /^\d+(\.)$/.test(v), v => v],
						[
							v => /^\d+(\.\d+)?$/.test(v),
							v => v.split('').slice(0, 4).join(''),
						],
					],
					value,
					value
				);
				this.$refs[target].value = inputValue;
				emit(inputValue);
			},
			onReviewCountInput(e, target) {
				const value = e.target.value.toString().split(',').join('');
				const emit = value =>
					this.emitsChange([
						{
							value,
							key: target,
						},
					]);

				if (value.length > 0) {
					const finalValue =
						Number(value) > 99999 ? 99999 : Number(value);
					const addedComma = util.currency(finalValue.toString());

					this.$refs[target].value = addedComma;
					emit(addedComma);
				} else {
					this.$refs[target].value = '';
					emit('');
				}
			},
			init() {
				this.categorySelector = false;
				this.$nextTick(() => {
					this.categorySelector = true;
				});
			},
			setCategory(query) {
				const args = {};
				if (query.firstCategory || query.firstCategory === 0) {
					args.category1 = Number(query.firstCategory);
					if (query.secondCategory || query.secondCategory === 0) {
						args.category2 = Number(query.secondCategory);
					}
					if (query.thirdCategory || query.thirdCategory === 0) {
						args.category3 = Number(query.thirdCategory);
					}
					this.$refs.categorySelector.setCategory(args);
				}
			},
			categoryChange({ category1, category2, category3 }) {
				this.emitsChange([
					{ key: 'firstCategory', value: category1 },
					{ key: 'secondCategory', value: category2 },
					{ key: 'thirdCategory', value: category3 },
				]);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.product-list-filter {
		.product-list-filter__category-selector {
			vertical-align: top;
		}

		.product-list-filter__id-product {
			width: 100%;
		}

		.range {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 1em;
		}

		.range__item {
			width: 100px;
		}
	}
</style>
